import { ChangeEvent, MouseEvent, useState } from "react";
import CreateCommercialUserForm from "./components/CreateCommercialUserForm";
import {
  CommerciaSignUpInput,
  CommerciaSignUpInputError,
} from "../../state/actionType";
import ValidateForm from "./components/ValidateForm";
import { connect } from "react-redux";
import {
  checkForExistingCommercialUserByEmail,
  checkForExistingCommercialUserByMobile,
  createCommercialUser,
} from "../../state/action";
import { ApiError } from "components";

interface OwnProps {
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateCommercialUser: React.FC<Props> = ({
  onClose,
  onCheckExistingEmail,
  onCheckExistingMobileNo,
  onCreateCommercialUser,
  // onResetCommercialData,
}) => {
  const [formData, setFormData] = useState<CommerciaSignUpInput>({
    mobile_no: "",
    name: "",
    gender: "",
    password: "",
    email: "",
  });
  const [error, setError] = useState<CommerciaSignUpInputError>({});
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setApiError("");

    const validationErrors = ValidateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }

    setIsLoading(true);
    const [emailCheck, mobileCheck] = await Promise.all([
      onCheckExistingEmail(formData.email),
      onCheckExistingMobileNo(formData.mobile_no),
    ]);
    if (!emailCheck.available || !mobileCheck.available) {
      setError({
        ...(emailCheck.available ? {} : { email: emailCheck.message }),
        ...(mobileCheck.available ? {} : { mobile_no: mobileCheck.message }),
      });
      setIsLoading(false);
      return;
    }

    const signup_input: CommerciaSignUpInput = {
      name: formData.name,
      mobile_no: formData.mobile_no,
      email: formData.email,
      gender: formData.gender,
      password: formData.password,
    };
    const result = await onCreateCommercialUser(signup_input);
    setIsLoading(false);
    if (result.success) {
      onClose();
    } else {
      setApiError(result.message ?? "Failed to create commercial user.");
    }
  };

  return (
    <>
      <CreateCommercialUserForm
        header={"Create Commercial User"}
        loading={isLoading}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateCommercialUser: (signup_input: CommerciaSignUpInput) =>
    dispatch(createCommercialUser(signup_input)),
  onCheckExistingMobileNo: (data: string) =>
    dispatch(checkForExistingCommercialUserByMobile(data)),
  onCheckExistingEmail: (data: string) =>
    dispatch(checkForExistingCommercialUserByEmail(data)),
});

export default connect(null, mapDispatchToProps)(HandleCreateCommercialUser);
